import {
  SET_AOL_CONFIG_MAP,
  SET_AOL_FOOTER_MENU,
  SET_AOL_HEADER_MENU,
  SET_AOL_NAME,
  SET_AOL_PAGE_RULES,
  SET_AOL_SEARCH_MENU,
  SET_AVAILABLE_AOL,
  SET_AOL_CONFIG_LOADED
} from './types'
import { DEFAULT_PAGES, SECTION_MAPPINGS } from 'constants/aol/sections'
import { AppDispatch, RootState } from 'redux/store';
import { AOLConfig, AOLPage, AOLSection, AvailbleAOL } from 'interfaces/aol';
import { AOLType } from 'types/AOL';

const emptyConfig: AOLConfig = { // "settings" when the AoL provided does not exist
  name: '',
  urlFragment: '',
  pages: {},
  sections:[],
  menus: {
    headerNav: [],
    footer: [],
    search: []
  }
}

export const setAolName = (name: AOLType = '') => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    const state: RootState = getState()

    dispatch({
      type: SET_AOL_NAME,
      name
    })

    const crntAolConfig = state.aol.aolConfigMap[name] || emptyConfig

    dispatch({
      type: SET_AOL_HEADER_MENU,
      headerMenu: crntAolConfig.menus.headerNav
    })

    dispatch({
      type: SET_AOL_FOOTER_MENU,
      footerMenu: crntAolConfig.menus.footer
    })

    dispatch({
      type: SET_AOL_SEARCH_MENU,
      searchMenu: crntAolConfig.menus.search
    })
    // FIX ME
    dispatch({
      type: SET_AOL_PAGE_RULES,
      pages: crntAolConfig.pages
    })
  }
}

export const setAolConfig = (config: AOLConfig[]) => {
  return (dispatch: AppDispatch, _:any) => {
    const getDefaultRules = (parameters: any) => DEFAULT_PAGES.reduce((rulesMap: Record<string, AOLPage>, page: string) => {
      rulesMap[page] = { availableToRoles: [], parameters }
      return rulesMap
    }, {})

    // given a section and the roles for that section, it checks what pages (controllers) are in that section and adds those pages with the access details to a map for that AOL
    const addSectionsPagesToMap = ({ section, availableToRoles, parameters }: AOLSection, map: Record<string, Partial<AOLSection>>): Record<string, Partial<AOLSection>> =>
      SECTION_MAPPINGS[section].reduce((mapObj: Record<string, Partial<AOLSection>>, page: string) => { // section mappings is a list of controllers that belong to an umbrella section
        mapObj[page] = { availableToRoles, parameters }
        return mapObj
      }, map)

    const configByFragment = config.reduce((map: Record<string, AOLConfig>, aolConfig: AOLConfig) => {
      // this basically all the section parameters built into an object like { QA: flavours: [] } which means any default page can have sectioned behavior
      // e.g. search and analytics now have the config from the sections to read from so we can have specific behaviour for actions related to those sections
      const defaultPageParams = aolConfig.sections.reduce((params: any, { section, parameters }: AOLSection) => ({ ...params, [section]: parameters }), {})
      // builds a map of every page with the access rules and config parameters in a nice generic way so that the AoL level can handle this behaviour in a standard way
      const pages:Record<string, AOLPage> = {
        ...getDefaultRules(defaultPageParams),
        ...aolConfig.sections.reduce((pageMap, section) => addSectionsPagesToMap(section, pageMap), {})
      }
      map[aolConfig.urlFragment] = { ...aolConfig, pages }
      return map
    }, {})

    dispatch({
      type: SET_AOL_CONFIG_MAP,
      aolConfigMap: configByFragment
    })

    const availableAol = config.map(({ name, urlFragment }: AvailbleAOL):AvailbleAOL => ({ name, urlFragment })) // this data is obviously around but thought it'd be useful to pull it out for easy access
    dispatch({
      type: SET_AVAILABLE_AOL,
      availableAol
    })

    dispatch({
      type: SET_AOL_CONFIG_LOADED,
      aolConfigLoaded: true
    })
  }
}
